import { makeStyles, withStyles } from '@material-ui/core/styles';
import { TableCell, TableRow, TextField } from '@material-ui/core';

export const StyledTableCell = withStyles(theme => ({
    body: {
      fontSize: 14,
      border: theme.palette.primary.main
    }
  }))(TableCell);
  
export const StyledTableRow = withStyles(theme => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.background.default
      }
    }
  }))(TableRow);
  
export const useStyles = makeStyles(theme => ({
    container: {
      display: "flex"
      // flexWrap: "wrap",
    },
    // textField: {
    //   marginLeft: theme.spacing(2),
    //   marginRight: theme.spacing(2),
    // },
    noteIcon: {
      cursor: "pointer" //Why not working??
    },
    button: {
      margin: theme.spacing(1)
    },
    typography: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: 20,
      width: 360,
      height: 200
    },
    textArea: {
      width: 300
    },
    textField: {
      minWidth: '20px'
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    // flexCenter: {
    //   display: "flex",
    //   justifyContent: "center",
    //   alignItems: "center"
    // }
  }));